<template>
  <div class="cpd-subsection-container">
    <div v-for="(subsection, i) of this.subsections" :key="i">
      <div class="cpd-subsection" :id="'cpd-subsection-b-' + i">
        <div class="cpd-subsection-name">
          {{ subsection.SubsectionName[0] }}
        </div>
        <div class="cpd-subsection-content">
          <span v-html="subsection.SubsectionContent[0]" />
        </div>
      </div>
      <template v-if="subsection.Subsection">
        <div
          v-for="(subsectionB, j) in subsection.Subsection"
          class="cpd-subsection-c"
          :key="'c-' + j"
        >
          <div class="cpd-subsection" :id="'cpd-subsection-c-' + i + '-' + j">
            <div class="cpd-subsection-name">
              {{ subsectionB.SubsectionName[0] }}
            </div>
            <div class="cpd-subsection-content">
              <span v-html="subsectionB.SubsectionContent[0]" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: 'Subsection',
  props: ['subsections'],
  data () {
    return {
      observer: null
    }
  },
  mounted () {
    this.addObserver()
  },
  updated () {
    this.observer = null
    this.addObserver()
  },
  methods: {
    addObserver () {
      let options = {
        rootMargin: '0% 0% -15% 0%',
        threshold: [0, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1]
      }
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const id = entry.target.getAttribute('id')
          if (document.querySelector(`.subhead-item-text[id="${id}"]`) !== null) {
            if (entry.intersectionRatio > 0.05) {
              document.querySelector(`.subhead-item-text[id="${id}"]`)
                .classList.add('active')
            } else {
              document.querySelector(`.subhead-item-text[id="${id}"]`)
                .classList.remove('active')
            }
          }
        })
      }, options)
      document.querySelectorAll('.cpd-subsection[id]').forEach((section) => {
        this.observer.observe(section)
      })
    }
  }
}
</script>

<style lang="scss">
.cpd-subsection-container {
  font-size: 16px;
  .cpd-subsection-name {
    font-weight: 700;
    font-size: 24px;
    padding: 16px 0px;
  }
  .cpd-subsection-content {
    table {
      text-align: center;
      font-size: 15px;
      tr:first-child td {
        background-color: #f2f2f2;
      }
      td {
        border: 1px solid #dadada;
      }
    }
  }
  .cpd-subsection-c {
    .cpd-subsection-name {
      font-size: 18px;
      font-weight: 700;
    }
  }
}
</style>
